import axios from 'axios'

import moment from 'moment'

export function fetchLoadBounties(filter) {
    const params = {
    }
    
    if (filter.pickup_date_begin) {
        params.pickup_date_begin = moment(filter.pickup_date_begin).format('YYYY-MM-DD')
    }
    if (filter.pickup_date_end) {
        params.pickup_date_end = moment(filter.pickup_date_end).format('YYYY-MM-DD')
    }
    if (filter.statuses?.length) {
        params.statuses = filter.statuses.join(',')
    }
    if (filter.user?.id) {
        params.creator_id = filter.user.id
    }

    return axios({
        method: 'get',
        url: `/api/load_bounties`,
        params
    })
}

export function addLoadBounty(bounty) {
    //max_buy_amount, bounty_amount, load_id, load_pro, active_until
    const data = {
        load_id: bounty.load?.id,
        bounty_amount: bounty.bounty_amount,
        max_buy_amount: bounty.max_buy_amount
    }
    if (bounty.active_until) {
        data.active_until = bounty.active_until
    }
    return axios({
        method: 'post',
        url: `/api/load_bounties`,
        data
    })
}

export function deleteLoadBounty(bounty) {
    return axios({
        method: 'delete',
        url: `/api/load_bounties/${bounty.id}`,
    })
}

export function updateUserBountyBudget(user, amount) {
    const data = {
        user_id: user?.id,
        amount
    }
    
    return axios({
        method: 'post',
        url: `/api/bounty_budgets`,
        data
    })
}

export function fetchUserBountyBudgets() {

    return axios({
        method: 'get',
        url: `/api/bounty_budgets`
    })
}
